import type { PlaybookNode } from "@repo/app-types/entities/playbook";
import { assertUnreachable } from "@repo/app-types/helpers/utilities";
import type {
  PlaybookCondition,
  PlaybookScoreCriterionComparesCondition,
  PlaybookScoreCriterionEqualsCondition,
  PlaybookYesNoCriterionEqualsCondition,
} from "./playbookCondition.js";

export function renderPlaybookCondition(
  allNodes: readonly PlaybookNode[] | undefined,
  condition: PlaybookCondition,
) {
  if ("kind" in condition) {
    return <span className="max-w-40 truncate">Playbook has result</span>;
  }

  if ("criterionId" in condition) {
    const subject =
      allNodes
        ?.filter((node) => node.type === "criteria")
        .find((node) => node.id === condition.criterionId)?.name ||
      "Unknown criterion";

    return (
      <>
        <span className="max-w-32 truncate">{subject}</span>
        <span>
          &nbsp;
          {condition.operator} {renderPlaybookConditionValue(condition.value)}
        </span>
      </>
    );
  }

  if ("sectionId" in condition) {
    const subject =
      allNodes
        ?.filter((node) => node.type === "section")
        .find((node) => node.id === condition.sectionId)?.name ||
      "Unknown section";

    return (
      <>
        <span className="max-w-32 truncate">{subject}</span>
        <span>
          &nbsp;{condition.value ? "is applicable" : "is not applicable"}
        </span>
      </>
    );
  }

  return assertUnreachable(condition, () => "Unknown result");
}

function renderPlaybookConditionValue(
  value: (
    | PlaybookYesNoCriterionEqualsCondition
    | PlaybookScoreCriterionEqualsCondition
    | PlaybookScoreCriterionComparesCondition
  )["value"],
) {
  if (typeof value === "boolean") {
    return value ? `"Yes"` : `"No"`;
  }

  if (typeof value === "number") {
    return value;
  }

  return assertUnreachable(value, () => "?");
}
